import { FC } from 'react';

import { OfferPreviewShell } from 'views/Offers/components/OfferPreviewShell';

const REWARD_CALENDAR_MOCK_ID = 'iphone-mock-reward-calendar';

export const RewardCalendarPreview: FC = () => {
  return (
    <OfferPreviewShell containerId={REWARD_CALENDAR_MOCK_ID}>
      {() => <div />}
    </OfferPreviewShell>
  );
};
